import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import { FaRegTrashAlt } from 'react-icons/fa';
import { BsDot } from 'react-icons/bs';
import { ObjModal } from '../../../../contexts';
import AddLeadOpp from '../../../Modals/AddLeadOpp';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { monthsShort } from '../../../../common/utils';
import { deleteLeadOpp } from '../../../../common/api';
import { toast } from 'react-toastify';


const LeadOpps = ( { aid, uid, settings } ) => {
    const { obj, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );
    const [ opps, setOpps ] = useState( [] );

    const trash = async ( laid, loid ) => {
        const removed = await deleteLeadOpp( laid, uid, loid );
        if ( removed.length ) {
            toast.success( `Your lead opp has been deleted`, { theme: 'dark' } );
            // window.location.reload( false );
        }
    };

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'leadopp':
                setModal( <AddLeadOpp close={closeModal} /> ); 
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const formatDate = ( d ) => {
        if ( d ) {
            const [ yr, mon, dd ] = d.replace( /[T\s].*/, '' ).split( '-' );
            return `${monthsShort[parseInt(mon) - 1]} ${dd}, ${yr}`;
        }
        return '';
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    useEffect( () => {
        const list = [];
        obj.leadopps.forEach( lo => {
            if ( !lo.lid ) {
                list.push( lo );
            } else {
                if ( !settings || !settings.leadopp || !settings.leadopp.hideLinkedLoan ) {
                    list.push( lo );
                } else {
                    console.log( 'hiding linked lo: ', lo );
                }
            }
        } );
        setOpps( list );
        setExpanded( list.length > 0 );
    }, [ obj.leadopps, settings ] );

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Lead Opportunities ({opps.length})</Typography></Col>
                        <Col xs='auto' className='p-0'>
                            <Button size='sm' variant='outline-primary' onClick={ () => handleModal( 'leadopp' ) }>+ Add</Button>
                        </Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <ListGroup variant='flush' className='overflow-scroll' style={ { maxHeight: '400px' } }>
                    {
                        opps.map( o => {
                            return (
                                <ListGroup.Item key={o.loid}>
                                   <Row className='align-items-center'>
                                        <Col xs='auto' className='tf-sidebar-obj-value'>
                                            {o.status}
                                        </Col>
                                        <Col>
                                            <Row className='align-items-center'>
                                                <Col xs='auto' className='p-1 ps-3 pb-0'>
                                                    <Link to={`/lead-opp/${o.loid}`}>{o.name}</Link>
                                                </Col>
                                            </Row>
                                            <Row className='align-items-center'>
                                                <Col xs='auto' className='p-1 ps-3 pt-0'>{ formatDate( o.oppDate ) }</Col>
                                                <Col xs='auto' className='p-0 pb-1'><BsDot /></Col>
                                                <Col xs='auto' className='p-1 pt-0'>{o.purpose}</Col>
                                            </Row>
                                        </Col>
                                        <Col xs='auto'><FaRegTrashAlt className='tf-sidebar-trash' onClick={ () => trash( o.aid, o.loid ) } /></Col>
                                    </Row>
                                </ListGroup.Item>
                            )
                        } )
                    }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    settings: state.user.meta.settings,
} );

const mapDispatch = ( dispatch ) => ( {
    // loadTasks: dispatch.contacts.loadContactTasks,
} );

export default connect( mapProps, mapDispatch )( LeadOpps );